import { GRAPHQL_ERROR_TYPES } from '@/shared/constants';
import {
  type AtsGetPublicListJobVacanciesCareerSiteQueryVariables,
  type AtsVacancyListGetJobVacanciesCareerSiteFragment,
  useAtsGetPublicListJobVacanciesCareerSiteQuery,
} from './graphql/get-public-list-job-vacancies-career-site.v5.generated';

export const useListJobVacancyCareerSiteAdmin = (
  variables: AtsGetPublicListJobVacanciesCareerSiteQueryVariables,
) => {
  const getListJobVacancyAdmin = useAtsGetPublicListJobVacanciesCareerSiteQuery(
    {
      variables,
      context: {
        clientName: 'v5',
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    },
  );

  if (
    getListJobVacancyAdmin.error ||
    GRAPHQL_ERROR_TYPES.includes(
      getListJobVacancyAdmin.data?.ats_recruitment.list_vacancies_career_site
        ?.__typename as any,
    )
  ) {
    const typedError =
      getListJobVacancyAdmin.data?.ats_recruitment.list_vacancies_career_site;
    const errorMessage =
      getListJobVacancyAdmin.error?.message ||
      (typedError && 'message' in typedError
        ? typedError.message
        : undefined) ||
      'Unknown error';

    return {
      ...getListJobVacancyAdmin,

      error: errorMessage,
      data: null,
    };
  }
  if (
    getListJobVacancyAdmin.data?.ats_recruitment.list_vacancies_career_site
      ?.__typename === 'ATSVacancyConnection'
  ) {
    return {
      ...getListJobVacancyAdmin,
      data: getListJobVacancyAdmin.data?.ats_recruitment
        .list_vacancies_career_site as AtsVacancyListGetJobVacanciesCareerSiteFragment,
    };
  }

  return {
    ...getListJobVacancyAdmin,
    data: null,
    error: 'Unexpected response structure: missing ATSVacancyConnection data',
  };
};
